<template>
    <!-- NB: this content should never actually show... -->
    <div/>
</template>

<script>

import Vue from 'vue'

/**
 * Page for admin to create equipment for a company
 */
export default Vue.extend({
    name: 'EquipmentCreate',
    props: {
        companyId: Number
    },
    async mounted () {
        const response = await this.$api.createItem(this, 'equipment', { company_id: this.companyId })
        const equipmentId = response.body.id
        this.$router.replace(`/equipment/edit/${equipmentId}`)
    },
})

</script>

